import type { SVGProps } from 'react';

const SvgChevronArrowRightMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M8 4L16 12L8 20' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgChevronArrowRightMd;
